import { useCallback } from "react";

const SMS_NUMBER = "22351";

/**
 * Handles the "apply" call-to-action used by the header button,
 * the image cards, and the primary CTA. Opens the device's SMS
 * app pre-filled to the application shortcode where supported.
 */
function useApplyAction() {
  return useCallback(() => {
    window.location.href = "./register";
  }, []);
}

export default useApplyAction;
